import VueGoogleAutocomplete from 'vue-google-autocomplete';
import {POSTAL_CODE_REQUEST} from "@/store/constant";

const event = {
  components: {
    VueGoogleAutocomplete
  },
  computed: {
    tagOptions() {
      const arr = this.tags.map(item => {
        return { id: item.id, title: item.title }
      })
      return arr;
    },
    communityOptions() {
      if (!this.communities) {
        return [];
      }
      const arr =  this.communities.filter(item => item.status === 'active' && item.isActive).map(item => {
        return { value: item.id, text: item.title }
      });
      arr.unshift({ value: '', text: 'コミュニティを選択してください' });
      return arr;
    },
  },
  watch: {
    addressType(newProp) {
      if (newProp === 'location') {
        this.mapUrl = null;
        this.address = null;
        if (this.form) {
          this.form.address = null;
        }
      }
      else if (newProp === 'address') {
        this.location = null;
      }
    }
  },
  methods: {
    getAddressData: function (addressData, placeResultData) {
      console.log(addressData, placeResultData);
      const { longitude, latitude, postal_code, locality } = addressData;
      this.mapUrl = placeResultData.url;
      this.address = placeResultData.formatted_address;
      this.detailed_location = { type: 'Point', coordinates: [longitude, latitude], locality, postalCode: postal_code };
      const formattedPostalCode = addressData.postal_code.replace('-', '');
      this.$store.dispatch(POSTAL_CODE_REQUEST, formattedPostalCode)
        .then(resp => {
          const data = resp.data[0];
          this.cityFromPostalCode = `【${data.prefecture}】${data.city}`;
        })
    }
  }
}

export default event
